module.exports = __webpack_public_path__ + "img/thumb_24.b5585da0.jpg";